export default {
  SYSTEM: 1,
  REQUEST_SENT_TO_CLUB: 2,
  REQUEST_CONFIRMATION_APPROVED: 3,
  REQUEST_CONFIRMATION_DENIED: 4,
  REQUEST_CONFIRMATION_CANCELLED: 13,
};
